export default __webpack_public_path__ + "static/media/gallery_00.9a0d8d8e.jpg";